import { List } from 'immutable'
import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { ParsedMenuItem } from '../../drupal/types_and_parser/extra_types.mod'
import { getFooter, getPrivacyMenu } from './api'

export type FooterState = {
  menu: AsyncState<List<ParsedMenuItem>>
  privacyMenu: AsyncState<List<ParsedMenuItem>>
}

export const initialFooterState = (): FooterState => ({
  menu: loadingAsyncState(() => getFooter()),
  privacyMenu: loadingAsyncState(() => getPrivacyMenu())
})
